
let logoutTimeout: number | undefined;

export const forceLogoutToLogin = (): void => {
    // Prevent multiple forced logouts from stacking
    if (logoutTimeout) {
        window.clearTimeout(logoutTimeout);
    }
    logoutTimeout = window.setTimeout(() => {
        localStorage.setItem('accessToken', '');
        localStorage.removeItem('userRole');
        localStorage.removeItem('userDetails');
        localStorage.removeItem('userDetailsEUM');

        const logoutSignal = Date.now().toString();
        localStorage.setItem('logout', logoutSignal);

        window.dispatchEvent(new StorageEvent('storage', { key: 'logout', newValue: logoutSignal }));
        logoutTimeout = undefined;
    }, 0);
};
